// TODO: Add tests.
export function getIncreasedBetAmount(betSliderAmount, betSliderMaxAmount, betIncrement) {
    return Math.min(betSliderAmount + betIncrement, betSliderMaxAmount);
}
// TODO: Add tests.
export function getDecreasedBetAmount(betSliderAmount, betSliderMinAmount, betIncrement) {
    let newValue;
    if ((betSliderAmount - betSliderMinAmount) % betIncrement === 0) {
        // bet slider is at a whole number divisions of bet increment, decrease by full bet increment:
        newValue = betSliderAmount - betIncrement;
    }
    else {
        // bet slider is not at a whole number divisions of bet increment, so just decrease to the next lowest increment:
        newValue = Math.floor((betSliderAmount - betSliderMinAmount) / betIncrement) * betIncrement + betSliderMinAmount;
    }
    return Math.max(newValue, betSliderMinAmount);
}
